import { getCountries } from "libphonenumber-js/max";

export interface CountryOption {
  /** ISO 3166-1 alpha-2, exactly what the API's `countryCode` field expects. */
  code: string;
  name: string;
}

/**
 * Every ISO 3166-1 alpha-2 country code + its display name — sourced from
 * libphonenumber-js's own country list (already a dependency, via
 * PhoneNumberField) and the browser's built-in Intl.DisplayNames, so this
 * needs no separate country-list package. Picking from this list instead of
 * free-typing a country name is what guarantees a valid `countryCode` reaches
 * the API — typing "United States of America" instead of "United States",
 * or leaving the code out entirely, is what causes a live 400
 * ("countryCode must be longer than or equal to 2 characters").
 */
export const COUNTRIES: CountryOption[] = getCountries()
  .map((code) => ({ code, name: new Intl.DisplayNames(["en"], { type: "region" }).of(code) ?? code }))
  .sort((a, b) => a.name.localeCompare(b.name));
